import React from 'react';

function PlayButtonIcon() {
    return (
        <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="36" cy="36" r="36" fill="white"/>
            <path d="M44 36L33.5 42.0622L33.5 29.9378L44 36Z" fill="black"/>
        </svg>
    );
}

export default PlayButtonIcon;
